'use client';
import { PropsWithChildren, useEffect } from 'react';
import { useAuth } from 'react-oidc-context';

import { LoadingOverlay } from '@/components/static';
import { useUpdateCookieToken } from '@/hooks/oidc';
import { getFullCurrentPath } from '@/utils/routes';

import s from './styles.module.scss';

export function OIDCLoginRedirect({ children }: PropsWithChildren) {
  const { signinRedirect } = useAuth();

  const authChecked = useUpdateCookieToken();
  useEffect(() => {
    if (authChecked) {
      signinRedirect({ redirect_uri: getFullCurrentPath(window.location) });
    }
  }, [authChecked, signinRedirect]);

  return (
    <LoadingOverlay
      rootCn={s.no_content_overlay_wrapper}
      loaderClassName={s.loading_overlay_layer}
      blurClassName={s.loading_overlay_layer}
      isLoading
    >
      {children}
    </LoadingOverlay>
  );
}
